import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";
import type { TolgeeInstance } from "@tolgee/react";

/**
 * Keeps `<html lang>` on the language the UI is in. `index.html` ships it as
 * English, and `hyphens: auto` breaks words by that language's rules: a German
 * word laid out under English rules had no break point and was cut before its
 * last letter instead (FS-3337). Screen readers read it too.
 *
 * Returns the unsubscribe.
 */
export const syncDocumentLanguage = (
  tolgee: Pick<TolgeeInstance, "getLanguage" | "on">,
  root: HTMLElement = document.documentElement
): (() => void) => {
  const apply = () => {
    root.lang = tolgee.getLanguage() ?? ENGLISH_LANG_CODE;
  };

  apply();
  const subscription = tolgee.on("language", apply);

  return () => subscription.unsubscribe();
};
